export const PermissionKeys = {
  MonitorView: "monitor.view",
  TrackView: "track.view",

  DeviceView: "device.view",
  DeviceCreate: "device.create",
  DeviceUpdate: "device.update",
  DeviceDelete: "device.delete",
  DeviceGroupUpdate: "device.group.update",
  DeviceShareView: "device.share.view",
  DeviceShareUpdate: "device.share.update",

  UserView: "user.view",
  UserCreate: "user.create",
  UserUpdate: "user.update",
  UserDelete: "user.delete",
  UserRoleUpdate: "user.role.update",
  UserPasswordReset: "user.password.reset",

  GroupView: "group.view",
  GroupCreate: "group.create",
  GroupUpdate: "group.update",
  GroupDelete: "group.delete",

  EmployeeView: "employee.view",
  EmployeeCreate: "employee.create",
  EmployeeUpdate: "employee.update",
  EmployeeDelete: "employee.delete",

  ConnectionLogView: "connection_log.view",
  AlarmLogView: "alarm_log.view",
  SystemOpLogView: "system_op_log.view",

  PermissionManage: "permission.manage",

  GggManagerManage: "ggg_manager.manage",
  GggManagerView: "ggg.manager.view",
  GggServiceView: "ggg.service.view",
  GggServiceManage: "ggg.service.manage",
  GggClientView: "ggg.client.view",
  GggAlarmView: "ggg.alarm.view",
  GggAlarmConfig: "ggg.alarm.config",
  GggDeviceCommand: "ggg.device.command",
  GggDeviceParameter: "ggg.device.parameter",
  GggFirmwareUpgrade: "ggg.firmware.upgrade",
  GggProgramConfig: "ggg.program.config"
};
